import { render, staticRenderFns } from "./EditTicketDetails.vue?vue&type=template&id=f803af5a&scoped=true"
import script from "./EditTicketDetails.vue?vue&type=script&lang=js"
export * from "./EditTicketDetails.vue?vue&type=script&lang=js"
import style0 from "./EditTicketDetails.vue?vue&type=style&index=0&id=f803af5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f803af5a",
  null
  
)

export default component.exports